import { useEffect } from 'react';
import { useFormError, useFormSaveStatus, useFormSubmissionStatus } from '@hooks';

import { ApiEndpoint, FormType } from '@enums';
import { resetSubmitFormState } from '@store';
import { EndpointType } from '@types';
import { useAppDispatch } from '../storeHooks';

interface UseFormSubmissionProps {
  formType: FormType;
  endpoint?: EndpointType;
  callbackFunction?: {
    close: () => void;
    additional?: () => void;
  };
}

export const useFormSubmission = ({
  formType,
  endpoint = ApiEndpoint.DEFAULT,
  callbackFunction,
}: UseFormSubmissionProps) => {
  const dispatch = useAppDispatch();

  const submitError = useFormError({ formType });
  const isSubmitting = useFormSubmissionStatus({ formType, endpoint });
  const saveSuccess = useFormSaveStatus(formType);

  useEffect(() => {
    const isFormSubmitSuccess = !submitError && !isSubmitting && saveSuccess;

    if (isFormSubmitSuccess) {
      callbackFunction?.close();
      dispatch(resetSubmitFormState({ formType }));
      callbackFunction?.additional?.();
    }
  }, [submitError, isSubmitting, saveSuccess]);
};
